var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48973 1.2345C3.52461 1.19958 3.56605 1.17187 3.61168 1.15296C3.6573 1.13406 3.70622 1.12433 3.75562 1.12433C3.80501 1.12433 3.85393 1.13406 3.89955 1.15296C3.94518 1.17187 3.98662 1.19958 4.0215 1.2345L8.5281 5.7345C8.56307 5.76933 8.59082 5.81072 8.60975 5.85627C8.62868 5.90183 8.63843 5.95067 8.63843 6C8.63843 6.04932 8.62868 6.09817 8.60975 6.14372C8.59082 6.18928 8.56307 6.23066 8.5281 6.2655L4.0215 10.7655C3.95099 10.8359 3.85534 10.8755 3.75562 10.8755C3.65589 10.8755 3.56024 10.8359 3.48973 10.7655C3.41921 10.6951 3.37959 10.5996 3.37959 10.5C3.37959 10.4004 3.41921 10.3049 3.48973 10.2345L7.73118 6L3.48973 1.7655C3.45475 1.73066 3.427 1.68928 3.40807 1.64372C3.38914 1.59817 3.37939 1.54932 3.37939 1.5C3.37939 1.45067 3.38914 1.40183 3.40807 1.35627C3.427 1.31071 3.45475 1.26933 3.48973 1.2345Z",
    fill: "#6066A3",
    stroke: "#6066A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fd40ce40459270880edc39ebe647ec1c.svg";
export { ForwardRef as ReactComponent };